export default __webpack_public_path__ + "static/media/blog_inner_24.0db10cbc.jpg";